import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { Linking, Platform, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { Button } from 'react-native-elements';
import { appTheme } from '@/config/colors';
import { Links } from '@/config/links';

const styles = StyleSheet.create({
  textButtonWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },

  full: {
    flex: 1,
  },
});

function TherapistAnleitung() {
  const responsiveFontSize = useResponsiveFontSize(1);
  const getResponsiveFontSize = (factor: number) => {
    return responsiveFontSize * factor;
  };

  let responsiveStyles = StyleSheet.create({
    buttonStyle: {
      marginVertical: getResponsiveFontSize(1),
      backgroundColor: appTheme.primary,
      maxWidth: 400,
      padding: getResponsiveFontSize(1),
    },
    buttonTitleStyle: {
      fontSize: Platform.OS === 'web' ? 16 : getResponsiveFontSize(1.5),
    },
    textStyle: {
      fontSize: Platform.OS === 'web' ? 18 : getResponsiveFontSize(2),
      fontWeight: '400',
    },
  });

  return (
    <View style={styles.full}>
      <View style={styles.textButtonWrapper}>
        <Text style={responsiveStyles.textStyle}>
          Die Gebrauchsanweisung für Therapeut:innen finden Sie hier:
        </Text>
        <Button
          title="Anleitung im Browser öffnen"
          buttonStyle={responsiveStyles.buttonStyle}
          titleStyle={responsiveStyles.buttonTitleStyle}
          onPress={() => Linking.openURL(Links.anleitung.href)}
        />
      </View>
    </View>
  );
}

export default TherapistAnleitung;
